import { apiSlice } from '../../../api/apiSlice';
import { COACHING_SHOUTOUT_VIEW, CREATE_COACHING_SHOUTOUT_COMMENT, CREATE_COACHING_SHOUTOUT_COMMENT_REPLY, CREATE_COACHING_SHOUTOUT_REACTION, GET_BADGES} from '../../../constants';

export const shoutOutViewSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getShoutOutView: builder.query({
            
            query: (arg: any) => {
                const { employeeNumber, teamOption, employeeRole, searchOracleId } = arg;
                return {
                    url: COACHING_SHOUTOUT_VIEW,
                    params: {
                        employeeNumber,
                        teamOption,
                        employeeRole,
                        searchOracleId,
                    },
                };
            },
            providesTags: ["CoachingShoutOutView"],
        }),
        createShoutoutComment: builder.mutation({
                    query: (arg: any) => ({
                        url: CREATE_COACHING_SHOUTOUT_COMMENT,
                        method: 'POST',
                        body: arg,
                        headers: {
                            'Content-type': 'application/json; charset=UTF-8',
                        },
                    }),
                    invalidatesTags: ['CoachingShoutOutCarousel'],
                }),
                createShoutoutCommentReply: builder.mutation({
                    query: (arg: any) => ({
                        url: CREATE_COACHING_SHOUTOUT_COMMENT_REPLY,
                        method: 'POST',
                        body: arg,
                        headers: {
                            'Content-type': 'application/json; charset=UTF-8',
                        },
                    }),
                    invalidatesTags: ['CoachingShoutOutCarousel'],
                }),
                createShoutoutReaction: builder.mutation({
                    query: (arg: any) => ({
                        url: CREATE_COACHING_SHOUTOUT_REACTION,
                        method: 'POST',
                        body: arg,
                        headers: {
                            'Content-type': 'application/json; charset=UTF-8',
                        },
                    }),
                    invalidatesTags: ['CoachingShoutOutCarousel'],
                }),
                getBadges: builder.query({
                            query: () => {
                                return {
                                    url: GET_BADGES,
                                };
                            },
                        }),
    }),
});

export const { useGetShoutOutViewQuery,useCreateShoutoutCommentMutation,useCreateShoutoutCommentReplyMutation,useCreateShoutoutReactionMutation,
    useGetBadgesQuery
} =
shoutOutViewSlice;
